module.exports = __webpack_public_path__ + "static/media/slowSpeed.7edcff27.svg";